function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import AssignmentTemplatesSelf from "../../assets/images/illustrations/assignment_templates_self.svg";
import AssignmentTemplatesOrg from "../../assets/images/illustrations/assignment_templates_org.svg";
import AssignmentTemplatesNurture from "../../assets/images/illustrations/assignment_templates_nurture.svg";
import InfoIcon from "../../assets/images/general_icons/info.svg";
import Input from "../../core/form/fields/Input";
import React, { useState } from "react";
var TemplateVisibilities = function TemplateVisibilities(_ref) {
  var assignmentName = _ref.assignmentName,
    selected = _ref.selected,
    context = _ref.context,
    isRubrics = _ref.isRubrics,
    onChange = _ref.onChange;
  var _useState = useState(assignmentName),
    _useState2 = _slicedToArray(_useState, 2),
    templateName = _useState2[0],
    setTemplateName = _useState2[1];
  var _useState3 = useState(selected),
    _useState4 = _slicedToArray(_useState3, 2),
    visibility = _useState4[0],
    setVisibility = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    saveFeedback = _useState6[0],
    setSaveFeedback = _useState6[1];
  var disableFeedbackSave = context === 'assignment_creation' || isRubrics;
  var feedbackSaveText = isRubrics ? 'Learning objective feedback is not available with Rubrics.' : 'You must publish feedback on an assessment using this template to save learning objective feedback to the template too.';
  var handleVisibilityChange = function handleVisibilityChange(value) {
    setVisibility(value);
    onChange(value, templateName, saveFeedback);
  };
  var handleTemplateNameChange = function handleTemplateNameChange(e) {
    setTemplateName(e.currentTarget.value);
    onChange(visibility, e.currentTarget.value, saveFeedback);
  };
  var handleSavedFeedbackChanged = function handleSavedFeedbackChanged() {
    var value = !saveFeedback;
    setSaveFeedback(value);
    onChange(visibility, templateName, value);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "px-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "question font-size-18 mb-4"
  }, "Who do you want this template to be available to?"), /*#__PURE__*/React.createElement("div", {
    className: "row mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item-box py-4 px-3 cursor-pointer me-2 ".concat(selected === 'private' ? 'active' : ''),
    onClick: function onClick() {
      return handleVisibilityChange('private');
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-3 col-lg-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-end text-lg-center mb-3"
  }, /*#__PURE__*/React.createElement("img", {
    src: AssignmentTemplatesSelf
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-9 col-lg-12 text-lg-center d-flex flex-column justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item-box-title"
  }, "Only me"), /*#__PURE__*/React.createElement("div", {
    className: "item-box-subtitle"
  }, "Just for you to use again with any of your classes."))))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item-box py-4 px-3 cursor-pointer me-2 ".concat(selected === 'org' ? 'active' : ''),
    onClick: function onClick() {
      return handleVisibilityChange('org');
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-3 col-lg-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-end text-lg-center mb-3"
  }, /*#__PURE__*/React.createElement("img", {
    src: AssignmentTemplatesOrg
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-9 col-lg-12 text-lg-center d-flex flex-column justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item-box-title"
  }, "My Schools / Org"), /*#__PURE__*/React.createElement("div", {
    className: "item-box-subtitle"
  }, "Other teachers in your school can use in their classes."))))), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item-box py-4 px-3 h-100 cursor-pointer ".concat(selected === 'public' ? 'active' : ''),
    onClick: function onClick() {
      return handleVisibilityChange('public');
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-3 col-lg-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-end text-lg-center mb-3"
  }, /*#__PURE__*/React.createElement("img", {
    src: AssignmentTemplatesNurture
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-9 col-lg-12 text-lg-center d-flex flex-column justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item-box-title"
  }, "Nurture Space"), /*#__PURE__*/React.createElement("div", {
    className: "item-box-subtitle"
  }, "Template is publicly available globally on Nurture")))))), /*#__PURE__*/React.createElement("hr", {
    className: "light-divider"
  }), /*#__PURE__*/React.createElement("div", {
    className: "my-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-light feedback-alert"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-check"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    checked: saveFeedback,
    onChange: handleSavedFeedbackChanged,
    disabled: disableFeedbackSave,
    type: "checkbox",
    id: "feedbackAlert"
  }), /*#__PURE__*/React.createElement("label", {
    className: "form-check-label",
    htmlFor: "feedbackAlert"
  }, "Save learning objective feedback to template?")), /*#__PURE__*/React.createElement("small", {
    className: "mt-3 d-block"
  }, feedbackSaveText))), /*#__PURE__*/React.createElement("hr", {
    className: "light-divider"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, {
    value: templateName,
    onChange: handleTemplateNameChange,
    label: "Template name"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex info align-items-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: InfoIcon
  }), /*#__PURE__*/React.createElement("div", {
    className: "info-text ms-1"
  }, "Only the assessments details will become the template, no student information will be used."))));
};
export default TemplateVisibilities;